// extracted by mini-css-extract-plugin
module.exports = {"faq__wrapper":"FAQList_faq__wrapper__WCXWQ"};